import { init, ErrorBoundary } from "@sentry/react";
import { getConfigSync } from "storefront/GrailedAPI/v1/Config/getConfig";

const sentryInit = () => {
  const config = getConfigSync();

  init({
    debug: false,
    dsn: config.sentry.clientDsn,
    // Rendered by layouts/body/_global_variables.html.erb. Not config.env — that
    // is Rails.env, which reports "staging" for every stageX deploy.
    environment: window.DEPLOY_ENVIRONMENT || "development",
    maxBreadcrumbs: 10,
  });
};

export { ErrorBoundary, sentryInit };
